// test1184
(1184 && 0);
